import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getRatings() {
    yield takeEvery(actions.FETCH_RATINGS_REQUESTED, function* (action) {
        try {
          const ratings = yield call(actions.getRatings, action.payload);
          yield put({ type: actions.FETCH_RATINGS_SUCCEEDED, ratings });
        } catch (error) {
          yield put({ type: actions.FETCH_RATINGS_FAILED, error: error.message });
        }
    });
}

export function* deleteRate() {
    yield takeEvery(actions.DELETE_RATE_REQUESTED, function* (action) {
        try {
            const rate = yield call(actions.deleteRate, action.payload);
            yield put({ type: actions.DELETE_RATE_REQUESTED, rateDeleted: rate });
        } catch (error) {
            yield put({ type: actions.DELETE_RATE_FAILED, error: error.message });
        }
    });
}

export default function* rootSaga() {
  yield all([
    fork(getRatings),
    fork(deleteRate)
  ]);
}
